import { createContext, useContext } from "react";

/** Session display info from GET /api/Auth/me (cookie-backed); not a secret. */
export const AuthUserContext = createContext(null);

export function useAuthUser() {
  return useContext(AuthUserContext);
}
